import { useMediaQuery } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Icons from "../../../../Config/Images";
import {
  addToCartAPI,
  getCartAPI,
  updateQuantityInCartAPI,
} from "../../../../Store/Action/cartAction";
// import { getLoggedInUserDetailsAPI } from "../../../../Store/Action/UserAction";
import {
  addWishlistAPI,
  removeWishlistAPI,
} from "../../../../Store/Action/wishlistAction";
import CustomImageComponent from "../CustomImageComponent";
import "./ProductCard.css";
import {
  getProductByIdAPI,
  getProductDetailsAPI,
} from "../../../../Store/Action/productAction";
import {
  addToCart,
  updateCartItemQuantity,
} from "../../../../Store/Slice/cartSlice";
import {
  setCartItemCount,
  triggerCartChange,
} from "../../../../Store/Slice/popupTriggerSlice";
import {
  createPreOrderAPI,
} from "../../../../Store/Action/orderAction";
import VariantSelectionPopup from "../VariantSelectionPopup";

// Reusable ProductCard component
const ProductCard = ({
  image,
  title,
  productCode,
  netWeight,
  wastage,
  fine,
  isWishlist,
  product,
  onGetWishlistProduct,
  isWishlistVisited = false,
  flagCart,
  userRole,
  isWastageEnabled,
  pageNumber,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  const [quantity, setQuantity] = useState(product?.cart_quantity);
  // const [cartItems, setCartItems] = useState([]);
  const [productDetails, setProductDetails] = useState(null);
  const [openVariantModal, setOpenVariantModal] = useState(false);
  const [popupMode, setPopupMode] = useState("variant");

  // Define responsive image height based on screen size
  const is1440Screen = useMediaQuery("(max-width:1440px)");
  const is1280Screen = useMediaQuery("(max-width:1280px)");
  const is1200Screen = useMediaQuery("(max-width:1200px)");
  const is1100Screen = useMediaQuery("(max-width:1100px)");
  const is1000Screen = useMediaQuery("(max-width:1000px)");
  const is700Screen = useMediaQuery("(max-width:700px)");
  const is600Screen = useMediaQuery("(max-width:600px)");
  const is500Screen = useMediaQuery("(max-width:500px)");
  const is400SmallScreen = useMediaQuery("(max-width:400px)");
  const is375SmallScreen = useMediaQuery("(max-width:375px)");
  const is320SmallScreen = useMediaQuery("(max-width:320px)");

  const imageHeight = is320SmallScreen
    ? "170px"
    : is375SmallScreen
      ? "190px"
      : is400SmallScreen
        ? "200px"
        : is500Screen
          ? "200px"
          : is600Screen
            ? "200px"
            : is700Screen
              ? "190px"
              : is1000Screen
                ? "210px"
                : is1100Screen
                  ? "220px"
                  : is1200Screen
                    ? "235px"
                    : is1280Screen
                      ? "250px"
                      : is1440Screen
                        ? "260px"
                        : "276px";
  const cardHeight = is320SmallScreen
    ? "150px"
    : is375SmallScreen
      ? "175px"
      : is400SmallScreen
        ? "185px"
        : is500Screen
          ? "185px"
          : is600Screen
            ? "195px"
            : is700Screen
              ? "190px"
              : is1000Screen
                ? "210px"
                : is1100Screen
                  ? "215px"
                  : is1200Screen
                    ? "235px"
                    : is1280Screen
                      ? "250px"
                      : is1440Screen
                        ? "256px"
                        : "276px";

  const handleProductClick = (product) => {
    if (!product?.product_name) return; // Prevents errors if product_name is null/undefined
    // Custom slug creation logic
    const formattedName = product?.product_name
      .toLowerCase() // Convert to lowercase
      .trim() // Trim spaces at the beginning and end
      .replace(/\s+/g, "-") // Replace one or more spaces with a hyphen
      .replace(/[^a-z0-9\-]/g, "") // Remove all non-alphanumeric characters except hyphens
      .replace(/-+/g, "-") // Replace multiple hyphens with a single hyphen
      .replace(/^-+/, "") // Remove any leading hyphens
      .replace(/-+$/, ""); // Remove any trailing hyphens

    const slugWithId = `${formattedName}-${product.product_id}`;

    navigate(`/productDetail/${slugWithId}`, {
      state: { productId: product.product_id },
    });
  };

  const handleVariantPopup = (e, product, mode = "variant") => {
    e.stopPropagation();
    setPopupMode(mode);
    // const params = {
    //   product_id: product?.product_id,
    // };
    dispatch(
      getProductDetailsAPI({ product_id: product?.product_id }, (result) => {
        setOpenVariantModal(true);
        setProductDetails(result?.data?.[0]);
      }),
    );
  };

  const onWishlistClick = (e, product) => {
    e.stopPropagation();
    if (isWishlist) {
      const reqData = {
        wishlist_id: product?.wishlist_id,
        flag_deleted: true,
      };
      dispatch(
        removeWishlistAPI(reqData, (result) => {
          if (result?.status) {
            onGetWishlistProduct(pageNumber);
            // toast.success(result?.data?.message);
          } else {
            toast.error(
              result?.error?.message || "Failed to remove item from wishlist.",
            );
          }
        }),
      );
    } else {
      const userRequestData = { product_id: product.product_id };
      dispatch(
        addWishlistAPI(userRequestData, (result) => {
          if (result?.data?.status) {
            onGetWishlistProduct(pageNumber);
            // toast.success(result?.data?.message?.message);
          } else {
            toast.error(result?.data?.error?.message);
          }
        }),
      );
    }
  };

  const onAddToCartClick = (e, product) => {
    e.stopPropagation();
    const type = product?.product_category_type_name?.toLowerCase();

    if (type === "per pc product") {
      // Direct Add to Cart request

      const payload = {
        product_id: product.product_id,
        quantity: product.min_quantity,
      };

      dispatch(
        addToCartAPI(payload, (result) => {
          if (result?.status) {
            onGetWishlistProduct(pageNumber);
            dispatch(triggerCartChange());
            dispatch(
              getCartAPI({}, (res) => {
                dispatch(setCartItemCount(res?.total_count));
              }),
            );
          } else {
            toast.error(result?.error?.message);
          }
        }),
      );
    } else {
      // Normal product → open variant modal
      handleVariantPopup(e, product, "variant");
    }
  };

  const updateQuantity = (e, delta, action, product) => {
    e.stopPropagation();

    let currentQty = Number(product?.cart_quantity);

    if (action == "isIncrement") {
      currentQty += 1;
    } else if (action === "isDecrement") {
      currentQty -= 1;
    }

    const payload = {
      product_id: product.product_id,
      quantity: currentQty,
    };

    dispatch(
      addToCartAPI(payload, (result) => {
        if (result?.status) {
          dispatch(
            updateCartItemQuantity({
              productId: product?.product_id,
              quantity: result?.data?.[0]?.product_quantity,
            }),
          );
          dispatch(triggerCartChange());
          dispatch(
            getCartAPI({}, (result) => {
              const cartLength = result?.total_count;
              dispatch(setCartItemCount(cartLength));
            }),
          );
          // toast.success(result?.message?.message);
          onGetWishlistProduct(pageNumber);
          setQuantity(product?.cart_quantity);
        } else {
          toast.error(result?.error?.message);
        }
      }),
    );
  };

  const handlePreOrderClick = (e, product) => {
    // handleVariantPopup(e, product, "preorder");
    const reqData = {
      product_id: product.product_id,
      flag_pre_order: true, 
      // pre_order_weight: data.pre_order_weight,
    };

    dispatch(
      addWishlistAPI(reqData, (result) => {
        if (result?.data?.status) {
          toast.success(result?.data?.message?.message || "Pre-order added");
          setOpenVariantModal(false);
          onGetWishlistProduct(pageNumber);
        } else {
          toast.error(
            result?.data?.error?.message || "Failed to add pre-order",
          );
        }
      }),
    );

    // const reqData = {
    //   product_id: product?.product_id,
    //   pre_order_weight: product?.product_net_weight,
    // };
    // dispatch(
    //   addWishlistAPI(reqData, (result) => {
    //     if (result?.status) {
    //       toast?.success(result?.data?.message?.message);
    //       // navigate("/wishlist");
    //       onGetWishlistProduct(pageNumber);
    //     }
    //   })
    // );
  };

  useEffect(() => {
    setQuantity(product.cart_quantity);
  }, [product]);


  return (
    // <Card className="card" sx={{ height: 480 }} style={{ cursor: "pointer" }}>
    <div className="card" style={{ cursor: "pointer", position: "relative" }}>
      <div>
        <div
          style={{
            height: cardHeight,
            position: "relative",
          }}
        >
          <div
            style={{ position: "relative" }}
            onClick={() => handleProductClick(product)}
          >
            <CustomImageComponent
              src={image}
              width={"100%"}
              height={imageHeight}
            />
            {product?.product_status_name === "Out of stock" && (
              <div className="out-of-stock-label">Out of Stock</div>
            )}
            {product?.global_feedback_rating?.length > 0 && (
              <div className="ratingContainer-prod-card">
                <p>{product?.overall_rating} </p>
                <img src={Icons.ratingIcon} alt="" />
                <div className="vl uniqueVl"></div>
                <p>{product?.total_ratings_of_product}</p>
                {/* <p className="lightBlackText">{product?.overall_rating || 0}</p>
          <img src={Icons.ratingIcon} className="ratingIcon" alt="" />
          <div className="separator" />
          <p className="totalRatingText">
            {product?.total_ratings_of_product || 0}
          </p> */}
              </div>
            )}
          </div>
        </div>

        {/* <CardContent style={{ padding: "25px" }}> */}
        <div className="custom-product-lower-card">
          <div>
            <div
              className="firstRow"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <p className="paragraph-tag-prod-card-prod-name">{title}</p>
              <img
                className="wishlist-img"
                src={isWishlist ? Icons.redWishlistIcon : Icons.heartIcon}
                alt="Add to favorites"
                onClick={(e) => onWishlistClick(e, product)}
              />
            </div>
            {product?.product_category_type_name?.toLowerCase() ===
            "product" ? (
              <>
                <div
                  className="secondRow"
                  style={{ textAlign: "left", marginTop: "5px" }}
                >
                  <p className="paragraph-tag-prod-card-prod-net-weight">
                    Net weight : {product?.product_avg_net_weight} gm
                    {/* code: {product?.product_code} */}
                  </p>
                  {/* <p className="paragraph-tag-prod-card-prod-net-weight">
              Product code : {productCode ? `${productCode}` : "-"}
            </p> */}
                </div>
                <div
                  className="thirdRow"
                  style={{
                    textAlign: "left",
                    marginTop: "5px",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "6px",
                    alignItems: "center",
                  }}
                >
                  {isWastageEnabled === true &&
                    product?.mode_name === "Wastage" && (
                      <p className="paragraph-tag-prod-card-prod-net-weight">
                        Wastage : {wastage || "-"}
                      </p>
                    )}
                  {isWastageEnabled === true &&
                    product?.mode_name === "Wastage" && (
                      <div className="vl uniqueVl"></div>
                    )}
                  {product?.is_labour_enabled && (
                    <>
                      <p className="paragraph-tag-prod-card-prod-net-weight">
                        Labour
                        {product?.labour_type_code
                          ? ` (${product.labour_type_code})`
                          : ""}{" "}
                        : {product?.product_labour_amount || "-"}
                      </p>
                      {/* <div className="vl uniqueVl"></div> */}
                    </>
                  )}
                  <p className="paragraph-tag-prod-card-prod-net-weight">
                    Melting : {product?.product_stamp_value} (
                    {product?.product_melting_value})
                  </p>
                </div>
              </>
            ) : (
              <>
                <div
                  className="secondRow"
                  style={{ textAlign: "left", marginTop: "5px" }}
                >
                  <p className="paragraph-tag-prod-card-prod-net-weight">
                    {/* Net weight : {netWeight} gm */}
                    Pcs rate :{product?.product_per_pc_rate}
                  </p>
                </div>
                <div
                  className="thirdRow"
                  style={{
                    textAlign: "left",
                    marginTop: "5px",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "6px",
                    alignItems: "center",
                  }}
                >
                  <p className="paragraph-tag-prod-card-prod-net-weight">
                    {/* Melting (Purity) : {product?.product_stamp_value} */}
                    Category: {product?.product_category_name}
                  </p>

                  <div className="vl uniqueVl"></div>

                  <p className="paragraph-tag-prod-card-prod-net-weight">
                    stone color : {product?.color_stone_name}
                  </p>
                </div>
              </>
            )}
          </div>

          <div>
            <div className="fourthRow" style={{ marginTop: "10px" }}>
              <div className="addToCartBtn">
                {/* <button onClick={(e) => onAddToCartClick(e, product)}>
                {isWishlistVisited ? "Move to cart" : "Add to cart"}
              </button> */}
                {product?.product_status_name === "Out of stock" ? (
                  <button
                    style={{
                      color: "#ffffff",
                      backgroundColor: product?.flag_pre_order
                        ? "#B0B0B0"
                        : "#000000",
                      cursor: product?.flag_pre_order
                        ? "not-allowed"
                        : "pointer",
                    }}
                    onClick={(e) => handlePreOrderClick(e, product)}
                    disabled={product?.flag_pre_order}
                  >
                    Pre-Order
                  </button>
                ) : flagCart ? (
                  <>
                    {product?.product_category_type_name?.toLowerCase() !==
                    "per pc product" ? (
                      <>
                        {/* <div className="addToCartBtn">
                          <button onClick={(e) => onAddToCartClick(e, product)}>
                            {"Change Variant"}
                          </button>
                        </div> */}
                        <div className="inc-dec-div">
                          <div
                            className="dec-btn"
                            onClick={(e) =>
                              handleVariantPopup(e, product, "variant")
                            }
                          >
                            <img src={Icons.minusCircleIcon} alt="Decrease" />
                          </div>

                          <div className="value-btn">{quantity || 1}</div>

                          <div
                            className="inc-btn"
                            onClick={(e) =>
                              handleVariantPopup(e, product, "variant")
                            }
                          >
                            <img src={Icons.addCircleIcon} alt="Increase" />
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="inc-dec-div">
                        <div
                          className="dec-btn"
                          onClick={(e) =>
                            updateQuantity(e, -1, "isDecrement", product)
                          }
                        >
                          <img
                            src={Icons.minusCircleIcon}
                            alt="Decrease quantity"
                          />
                        </div>
                        <div className="value-btn">{quantity}</div>
                        <div
                          className="inc-btn"
                          onClick={(e) =>
                            updateQuantity(e, 1, "isIncrement", product)
                          }
                        >
                          <img
                            src={Icons.addCircleIcon}
                            alt="Increase quantity"
                          />
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <div className="addToCartBtn">
                    <button onClick={(e) => onAddToCartClick(e, product)}>
                      {isWishlistVisited ? "Move to cart" : "Add to cart"}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <VariantSelectionPopup
        open={openVariantModal}
        mode={popupMode}
        onClose={() => setOpenVariantModal(false)}
        product={productDetails}
        onSubmit={(selectedIds) => {
          const request = {
            product_id: productDetails.product_id,
            product_variant_id: selectedIds,
          };

          dispatch(
            addToCartAPI(request, (result) => {
              if (result?.status) {
                onGetWishlistProduct(pageNumber);
                setOpenVariantModal(false);
                dispatch(triggerCartChange());
                dispatch(
                  getCartAPI({}, (res) => {
                    dispatch(setCartItemCount(res?.total_count));
                  }),
                );
              }
            }),
          );
        }}
        onPreOrderSubmit={(data) => {
          // preorder handler
          const reqData = {
            product_id: data.product_id,
            // pre_order_weight: data.pre_order_weight,
            flag_pre_order: true,
          };

          dispatch(
            addWishlistAPI(reqData, (result) => {
              if (result?.data?.status) {
                toast.success(
                  result?.data?.message?.message || "Pre-order added",
                );
                setOpenVariantModal(false);
                onGetWishlistProduct(pageNumber);
              } else {
                toast.error(
                  result?.data?.error?.message || "Failed to add pre-order",
                );
              }
            }),
          );
        }}
      />
    </div>
  );
};
export default ProductCard;
